import { SectionShell } from "../components/home/SectionShell";
import { SectionTitle } from "../components/home/SectionTitle";

const galleryImages = {
  one: "/bg/bg1.jpg",
  two: "/bg/bg2.jpg",
  three: "/bg/bg3.jpg",
  four: "/bg/bg4.jpg",
};

const GalleryImage = ({ src, alt, wrapClass = "", priority = false }) => (
  <div className={`relative overflow-hidden rounded-2xl ${wrapClass}`}>
    <img
      src={src}
      alt={alt}
      className="absolute inset-0 h-full w-full object-cover"
      loading={priority ? "eager" : "lazy"}
      decoding="async"
      fetchpriority={priority ? "high" : "auto"}
    />
  </div>
);

export const Ultra24GallerySection = () => {
  return (
    <SectionShell id="ultra24-gallery" className="bg-white">
      <SectionTitle
        title="Race Atmosphere"
        subtitle="Cuplikan momen lintasan, energi penonton, dan pengalaman event INDONESIA ULTRA 24."
        align="center"
      />

      <div className="mt-10 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-12 lg:auto-rows-[180px]">
        <GalleryImage
          src={galleryImages.one}
          alt="Ultra24 Gallery 1"
          wrapClass="aspect-video sm:col-span-2 lg:aspect-auto lg:col-span-7 lg:row-span-2"
          priority
        />

        <GalleryImage
          src={galleryImages.two}
          alt="Ultra24 Gallery 2"
          wrapClass="aspect-[4/3] lg:aspect-auto lg:col-span-5"
        />

        <div className="relative overflow-hidden rounded-2xl border border-slate-800 bg-[#0b0f19] p-4 text-white sm:col-span-2 lg:col-span-5">
          <div
            className="pointer-events-none absolute inset-0 opacity-55"
            style={{
              backgroundImage:
                "radial-gradient(circle at center, rgba(148,163,184,0.55) 1.1px, transparent 1.2px)",
              backgroundSize: "18px 18px",
              backgroundPosition: "0 0",
            }}
          />
          <div className="absolute inset-0 bg-gradient-to-b from-transparent via-[#0b0f19]/40 to-[#0b0f19]/85" />
          <div className="relative z-10">
            <h3 className="mt-3 text-4xl font-black leading-tight text-white">Feel the energy.</h3>
            <p className="mt-2 text-sm text-slate-300">From start line to final lap, every moment feels alive.</p>
          </div>
        </div>

        <GalleryImage
          src={galleryImages.three}
          alt="Ultra24 Gallery 3"
          wrapClass="aspect-[4/3] lg:aspect-auto lg:col-span-6"
        />

        <GalleryImage
          src={galleryImages.four}
          alt="Ultra24 Gallery 4"
          wrapClass="aspect-[4/3] lg:aspect-auto lg:col-span-6"
        />
      </div>
    </SectionShell>
  );
};
